import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  salesMessage: string | undefined;
  traderMessage: string | undefined;
}>;

export type MessagesProps = OwnProps & StateProps;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (state, { tabId }) => {
  return {
    salesMessage: fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductSalesMessage(state, tabId),
    traderMessage: fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductTraderMessage(state, tabId),
  };
};

export const connectCpOrderMessages = connect(mapStateToProps);
